import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-reset-password',

  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css'],
})
export class ResetPasswordComponent {
  showPassword = false;
  showConfirmPassword = false;
  logo = './assets/' + environment.projectName + '/media/header/logo.png';
  lang: string = '';
  constructor(private route: ActivatedRoute) {
    this.route.params.subscribe((params) => {
      if (params) {
        this.lang = params['lang'];
      }
    });
  }
  toggleShowPassword() {
    this.showPassword = !this.showPassword;
  }
  toggleConfirmShowPassword() {
    this.showConfirmPassword = !this.showConfirmPassword;
  }
}
